const marketing = [
	{
		path: '/agency/marketing/providers/list',
		name: 'agency-marketing-providers-list',
		component: () => import('@/views/agency/marketing/providers/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/cases/list',
		name: 'agency-marketing-cases-list',
		component: () => import('@/views/agency/marketing/cases/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/cases/new',
		name: 'agency-marketing-cases-new',
		component: () => import('@/views/agency/marketing/cases/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/cases/edit/:id',
		name: 'agency-marketing-cases-edit',
		component: () =>
			import(/* webpackChunkName: "AgencyCasesEdit" */ '@/views/agency/marketing/cases/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/cases-types/list',
		name: 'agency-marketing-cases-types-list',
		component: () => import('@/views/agency/marketing/cases-types/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/campaigns/list',
		name: 'agency-marketing-campaigns-list',
		component: () => import('@/views/agency/marketing/campaigns/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/campaigns-banners/list',
		name: 'agency-marketing-campaigns-banners-list',
		component: () => import('@/views/agency/marketing/campaigns-banners/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		// The gate every banner passes before it is served: provisioning writes
		// it inactive with review_status pending (or awaiting_artwork), and
		// nothing goes live until it is approved here. The endpoints existed
		// from the start with no screen calling them, so a paid banner reached
		// pending review and stopped there forever.
		path: '/agency/marketing/banner-moderation',
		name: 'agency-marketing-banner-moderation',
		component: () => import('@/views/agency/marketing/banner-moderation/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		// The queue of banner art MGN owes a studio: a paid banner campaign whose
		// buyer asked us to design the creative instead of uploading their own.
		//
		// Reuses the editorial assignments board rather than a second screen —
		// it is the same table and the same assigned/in_progress/draft_ready
		// cycle. `contentType` seeds the board's filter so the queue opens on
		// banner work; the board itself is generic. Gated on MGAG,marketing to
		// sit with the banners it produces, not on MGAG,press-release, which is
		// what the same board is gated on when reached from the PR side.
		path: '/agency/marketing/banner-artwork',
		name: 'agency-marketing-banner-artwork',
		component: () => import('@/views/agency/press-release-assignments/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
			contentType: 'banner_creative',
		},
	},
	{
		path: '/agency/marketing/campaigns/new',
		name: 'agency-marketing-campaigns-new',
		component: () => import('@/views/agency/marketing/campaigns/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/campaigns/edit/:id',
		name: 'agency-marketing-campaigns-edit',
		component: () =>
			import(/* webpackChunkName: "AgencyCampaignsEdit" */ '@/views/agency/marketing/campaigns/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/campaigns-types/list',
		name: 'agency-marketing-campaigns-types-list',
		component: () => import('@/views/agency/marketing/campaigns-types/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/campaigns-categories/list',
		name: 'agency-marketing-campaigns-categories-list',
		component: () => import('@/views/agency/marketing/campaigns-categories/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/presentations/list',
		name: 'agency-marketing-presentations-list',
		component: () => import('@/views/agency/marketing/presentations/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/presentations/new',
		name: 'agency-marketing-presentations-new',
		component: () => import('@/views/agency/marketing/presentations/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/presentations/edit/:id',
		name: 'agency-marketing-presentations-edit',
		component: () =>
			import(/* webpackChunkName: "AgencyPresentationsEdit" */ '@/views/agency/marketing/presentations/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/age-ranges/list',
		name: 'agency-marketing-age-ranges-list',
		component: () => import('@/views/agency/marketing/age-ranges/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/brands/list',
		name: 'agency-marketing-brands-list',
		component: () => import('@/views/agency/marketing/brands/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/niches/list',
		name: 'agency-marketing-niches-list',
		component: () => import('@/views/agency/marketing/niches/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/ad-channels/list',
		name: 'agency-marketing-ad-channels-list',
		component: () => import('@/views/agency/marketing/ad-channels/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/ad-sizes/list',
		name: 'agency-marketing-ad-sizes-list',
		component: () => import('@/views/agency/marketing/ad-sizes/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/ad-formats/list',
		name: 'agency-marketing-ad-formats-list',
		component: () => import('@/views/agency/marketing/ad-formats/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/ad-types/list',
		name: 'agency-marketing-ad-types-list',
		component: () => import('@/views/agency/marketing/ad-types/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/kpi-groups/list',
		name: 'agency-marketing-kpi-groups-list',
		component: () => import('@/views/agency/marketing/kpi-groups/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/kpi-options/list',
		name: 'agency-marketing-kpi-options-list',
		component: () => import('@/views/agency/marketing/kpi-options/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/content-styles/list',
		name: 'agency-marketing-content-styles-list',
		component: () => import('@/views/agency/marketing/content-styles/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/gender-dominances/list',
		name: 'agency-marketing-gender-dominances-list',
		component: () => import('@/views/agency/marketing/gender-dominances/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/tracking-platforms/list',
		name: 'agency-marketing-tracking-platforms-list',
		component: () => import('@/views/agency/marketing/tracking-platforms/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/marketing/tiers/list',
		name: 'agency-marketing-tiers-list',
		component: () => import('@/views/agency/marketing/tiers/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
	{
		path: '/agency/feed-promotions',
		name: 'agency-feed-promotions',
		component: () => import('@/views/agency/feed-promotions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
]

export default marketing
